{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "أداة انتقاء اللون",
  "twoDimensionalSlider": "مُنزلق 2D",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
